import script from "./tabNav.vue?vue&type=script&setup=true&lang=js"
export * from "./tabNav.vue?vue&type=script&setup=true&lang=js"

import "./tabNav.vue?vue&type=style&index=0&id=246705ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246705ee"]])

export default __exports__